import { render, staticRenderFns } from "./TabDeclarations.vue?vue&type=template&id=4e819962&scoped=true&"
import script from "./TabDeclarations.vue?vue&type=script&lang=js&"
export * from "./TabDeclarations.vue?vue&type=script&lang=js&"
import style0 from "./TabDeclarations.vue?vue&type=style&index=0&id=4e819962&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e819962",
  null
  
)

export default component.exports